var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7995_8222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.32281V17.3228C4.9475 16.9478 2 13.7303 2 9.82281C2 5.91531 4.9475 2.69781 8.75 2.32281ZM10.2725 2.32281V9.06531H17C16.6475 5.51031 13.82 2.67531 10.2725 2.32281ZM10.2725 10.5803V17.3228C13.8275 16.9703 16.6475 14.1353 17 10.5803H10.2725Z",
    fill: "#6FCF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7995_8222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.822815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c035cead60b875eb1cedb61b1d00f924.svg";
export { ForwardRef as ReactComponent };